export const keys = {
  nItem: "nItem",
  numItem: "numItem",
  xProd: "xProd",
  descrItem: "descrItem",
  cfop: "cfop",
  cstIcms: "cstIcms",
  vlItem: "vlItem",
  vlDesc: "vlDesc",
  vlBcIcms: "vlBcIcms",
  vIcms: "vIcms",
  aliqIcms: "aliqIcms",
  vlIcms: "vlIcms",
  cProd: "cProd",
  codItem: "codItem",
  operacao: "operacao",
  qtd: "qtd",
  codCta: "codCta",
  vlLiquido: "vlLiquido",
  operacaoContabil: "operacaoContabil",
  nomeCta: "nomeCta",
  codigoDominio: "codigoDominio",
  idRegC170: "idRegC170",
  ncm: "ncm",
  cpfCnpj: "cpfCnpj",
  numDoc: "numDoc",
  nome: "nome",
  vlMerc: "vlMerc",
  vlDoc: "vlDoc",
  codCtaExt: "codCtaExt",
  vlContabil: "vlContabil",
  vlDominio: "vlDominio",
  uf: "uf",
  codNcm: "codNcm",
  vlIcmsSt: "vlIcmsSt",
  dtDoc2: "dtDoc2",
};
